import React, { FC } from 'react'
import dynamic from 'next/dynamic'
import { useTranslation } from 'react-i18next'
import {
  Box,
  Flex,
  Heading,
  useBreakpointValue,
} from '@chakra-ui/react'
import { TextLink } from 'src/uikit'
import { ArrowForwardIcon } from '@chakra-ui/icons'
import router from 'next/router'

const Breadcrumbs = dynamic(() => import('src/components/Breadcrumbs'))
const Autocomplete = dynamic(() => import('src/components/Autocomplete'))

interface Props {
  title: string
  description: string
  crumbs: Array<any>
  linkHref?: string
  linkTitle?: string
  searchAutoCompleteItems?: Array<any>
  domain: string
  resultFormatter?: (...args: any[]) => { label: any; value: any };
}

const PageHeaderContainer: FC<Props> = ({
  title,
  description,
  crumbs,
  linkHref,
  linkTitle,
  searchAutoCompleteItems = [],
  domain,
  resultFormatter
}) => {
  const { t } = useTranslation()
  const isMobile = useBreakpointValue({ base: true, md: false })

  return <>
    <Flex display={{ base: 'none', md: 'flex' }}>
      <Breadcrumbs items={crumbs} />
    </Flex>
    <Heading as="h1" fontSize="2xl" fontFamily="Montserrat-SemiBold" textAlign="left" px="l" pt={{ base: 'l', md: '0' }}>
      {title}
    </Heading>
    <Box px="l" pt="s" pb="l" display={{ md: 'flex' }} tabIndex={-1}>
      <Box width={{ base: '100%', md: '65%' }} textAlign="left">
        <Box
          marginTop="s"
          color="baseNeutral.700"
          fontFamily="Montserrat-Medium"
          fontSize="md"
          className="landing-text"
          display="inline"
          dangerouslySetInnerHTML={{ __html: description }}
        />
        {linkHref && linkTitle &&
          <TextLink
            href={linkHref}
            title={linkTitle}
            color="primaryGreen.600"
            fontFamily="Montserrat-SemiBold"
            marginLeft="0.75rem"
          >
            {linkTitle} <ArrowForwardIcon />
          </TextLink>
        }
      </Box>

      <Box width={{ base: '100%', md: '35%' }} alignItems="center" pl={{ base: '0', md: 'l' }}>
        <Autocomplete
          items={searchAutoCompleteItems}
          disableFilter={true}
          apiPath={domain === 'sell' ? 'search/sell/term' : 'search/rent/term'}
          onSelect={selected => domain === 'sell'
            ? router.push(selected)
            : router.push(`/noleggio-a-lungo-termine/${selected.replace(' ', '/')}`)
          }
          placeholder={isMobile ? t('pageHeaderContainer:placeholderMobile') : t('pageHeaderContainer:placeholder')}
          notFoundText={t('pageHeaderContainer:nothingFound')}
          withOverlay
          mt={{ base: 4, md: 0 }}
          resultFormatter = {resultFormatter}
        />
      </Box>
    </Box>
  </>
}

export default PageHeaderContainer
